// Twilio Voice SDK Configuration
import { TwilioCallStatus } from '@/constants/twilioCallStatus';
import { isHumanCallState } from '@/utils/caseStateHelpers';

// UI configuration for different call statuses
const TWILIO_CALL_STATUS_STYLES = {
  [TwilioCallStatus.IDLE]: {
    headerBg: 'bg-muted',
    indicatorColor: '',
    animation: '',
  },
  [TwilioCallStatus.PENDING]: {
    headerBg: 'bg-yellow-50 dark:bg-yellow-950/20',
    indicatorColor: '',
    animation: 'animate-pulse',
  },
  [TwilioCallStatus.CONNECTING]: {
    headerBg: 'bg-yellow-50 dark:bg-yellow-950/20',
    indicatorColor: '',
    animation: 'animate-pulse',
  },
  [TwilioCallStatus.RINGING]: {
    headerBg: 'bg-blue-50 dark:bg-blue-950/20',
    indicatorColor: '',
    animation: 'animate-pulse',
  },
  [TwilioCallStatus.CONNECTED]: {
    headerBg: 'bg-blue-50 dark:bg-blue-950/20',
    indicatorColor: 'bg-red-500',
    animation: '',
  },
  [TwilioCallStatus.RECONNECTING]: {
    headerBg: 'bg-orange-50 dark:bg-orange-950/20',
    indicatorColor: '',
    animation: 'animate-pulse',
  },
  [TwilioCallStatus.DISCONNECTED]: {
    headerBg: 'bg-indigo-50 dark:bg-indigo-950/20',
    indicatorColor: '',
    animation: '',
  },
  [TwilioCallStatus.CANCELLED]: {
    headerBg: 'bg-indigo-50 dark:bg-indigo-950/20',
    indicatorColor: '',
    animation: '',
  },
} as const;

// Helper function to check if call button should be shown
// Supports both generic 'human_call' and phase-specific states like 'primary_human_call', 'secondary_human_call'
export function shouldShowCallButton(state: string): boolean {
  return isHumanCallState(state);
}

// Helper function to get status styles
export function getTwilioCallStatusStyle(status: TwilioCallStatus) {
  return TWILIO_CALL_STATUS_STYLES[status] || TWILIO_CALL_STATUS_STYLES[TwilioCallStatus.IDLE];
}
